
// 放配合 modal使用的工具函数  尽量写可配置

import { MessageBox } from 'element-ui';
// 剔除提示
export function delErrList(
    {
        tip, list, options ={},
        onOk=()=>{}, 
        colse = ()=> {} 
    }, 
) {
    let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
    htmlStr += `<p>${tip}</p>`;
    htmlStr += '<p class="font12px">'+(list.join('、'))+`</p></div>`;
    MessageBox.confirm(htmlStr, '提示', {
        confirmButtonText: '剔除',
        cancelButtonText: '关闭',
        dangerouslyUseHTMLString: true,
        type: 'error',
        customClass:'batch-err-tips-modal',
        width:'500',
        ...options
    }).then(()=>{
        onOk()
    }).catch(()=> {
        colse()
    });
}

/**
 * 复制文本到剪贴板。
 * ⚠️ 必须带 fallback：内网 http 是**非安全上下文**，navigator.clipboard 直接是 undefined，
 *    只判 `navigator.clipboard &&` 还不够 —— 部分浏览器对象在，调用时才 reject。
 */
export function copyTextToClipboard(text) {
    const str = String(text == null ? '' : text);
    if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(str);
    }

    return new Promise((resolve, reject) => {
        const ta = document.createElement('textarea');
        ta.value = str;
        // 定位到视口外，避免 select() 触发页面滚动
        ta.style.position = 'fixed';
        ta.style.top = '-9999px';
        ta.style.opacity = '0';
        ta.setAttribute('readonly', 'readonly');
        document.body.appendChild(ta);
        ta.select();
        ta.setSelectionRange(0, ta.value.length);
        let ok = false;
        try {
            ok = document.execCommand('copy');
        } catch (e) {
            ok = false;
        }
        document.body.removeChild(ta);
        ok ? resolve() : reject(new Error('copy failed'));
    });
}

/**
 * 批量查询「未找到工单」按状态归类的提示弹框（2026-07-22·排单 / 指派 / 任务共用）。
 *
 * 与 delErrList 的关系：**只换展示，不换语义**。
 *   · 底部「剔除」按钮做的事一模一样 —— 把 err_list 里的串从本次批量筛选中移除。
 *   · 新增的只是「告诉用户这些单其实存在、在哪个状态」，以及按组一键复制。
 * 后端 err_groups 为空（或非 work_order 类型）时调用方应退回 delErrList。
 *
 * @param {Array} groups  后端 err_groups：[{key,name,items,copy_text}]
 *                        前三组 items 为 {id, order_name}，not_found 组为 {raw}
 */
export function delErrGroupList(
    {
        groups = [], tip, options = {},
        onOk = () => {},
        colse = () => {}
    },
) {
    const esc = (v) => String(v == null ? '' : v)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

    // 每组最多展示的条目数：用户可能一次粘 300 个，全量平铺会撑爆弹框。
    // 用户真正关心的是「分好类 + 数量 + 一键复制」，逐条明细只需露一部分。
    // 复制走后端给的 copy_text（**该组全部**），不受这里截断影响。
    const PREVIEW_N = 10;
    const total = (groups || []).reduce((n, g) => n + ((g.items || []).length), 0);

    let htmlStr = '<div class="batch-err-groups">';
    // 顶部固定区（不随内容滚动）：主提示 + 一条操作说明 tips
    htmlStr += `<p style="margin:0 0 6px;">${esc(tip)}</p>`;
    htmlStr += '<p style="margin:0 0 8px;padding:6px 10px;background:#ecf5ff;border:1px solid #d9ecff;'
        + 'border-radius:4px;font-size:12px;color:#409eff;line-height:18px;">'
        + `共 <b>${total}</b> 个未匹配到当前列表，已按工单当前状态归类。`
        + '每组仅展示前若干条，点该组<b>「复制」</b>可复制<b>全部</b>工单 ID，粘回搜索框重搜。</p>';

    // 分组滚动区：整体限高，组多/条目多时在此滚动，不把整个弹框顶出屏幕
    htmlStr += '<div style="max-height:46vh;overflow-y:auto;padding-right:2px;">';
    (groups || []).forEach((g, gi) => {
        const items = g.items || [];
        const shown = items.slice(0, PREVIEW_N);
        const rest = items.length - shown.length;
        htmlStr += '<div style="margin-bottom:10px;border:1px solid #ebeef5;border-radius:4px;">';
        // 组头：名称 + 数量 + 复制。sticky 让长组滚动时组头留顶，始终看得到是哪个组
        htmlStr += '<div style="position:sticky;top:0;z-index:1;display:flex;align-items:center;'
            + 'justify-content:space-between;padding:6px 10px;background:#f5f7fa;border-radius:4px 4px 0 0;">';
        htmlStr += `<span style="font-weight:600;color:#303133;">${esc(g.name)}`
            + `<span style="color:#909399;font-weight:400;">（${items.length}）</span></span>`;
        // data-copy-idx 由下方事件委托读取，取 groups[idx].copy_text —— 不把长文本塞进 DOM 属性
        htmlStr += `<button type="button" class="batch-err-copy-btn" data-copy-idx="${gi}"`
            + ' style="cursor:pointer;border:1px solid #dcdfe6;background:#fff;border-radius:3px;'
            + 'padding:2px 10px;font-size:12px;color:#606266;">复制</button>';
        htmlStr += '</div>';
        htmlStr += '<div style="padding:6px 10px;font-size:12px;color:#606266;">';
        shown.forEach((it) => {
            htmlStr += it.raw !== undefined
                ? `<div style="line-height:20px;">${esc(it.raw)}</div>`
                : `<div style="line-height:20px;"><span style="color:#303133;">${esc(it.id)}</span>`
                  + `　${esc(it.order_name)}</div>`;
        });
        if (rest > 0) {
            htmlStr += `<div style="line-height:20px;color:#c0c4cc;">…… 还有 ${rest} 个，`
                + '点上方「复制」可复制该组全部工单 ID</div>';
        }
        htmlStr += '</div></div>';
    });
    htmlStr += '</div></div>';

    // MessageBox 用 HTML string 渲染，按钮事件只能靠委托。绑在 document 上、关框时移除。
    const onDocClick = (e) => {
        const btn = e.target && e.target.closest && e.target.closest('.batch-err-copy-btn');
        if (!btn) return;
        const g = (groups || [])[Number(btn.getAttribute('data-copy-idx'))];
        if (!g) return;
        copyTextToClipboard(g.copy_text || '')
            .then(() => { btn.textContent = '已复制'; setTimeout(() => { btn.textContent = '复制'; }, 1500); })
            .catch(() => { btn.textContent = '复制失败'; setTimeout(() => { btn.textContent = '复制'; }, 1500); });
    };
    document.addEventListener('click', onDocClick);
    const teardown = () => document.removeEventListener('click', onDocClick);

    MessageBox.confirm(htmlStr, '提示', {
        confirmButtonText: '剔除',
        cancelButtonText: '关闭',
        dangerouslyUseHTMLString: true,
        type: 'error',
        customClass: 'batch-err-tips-modal',
        width: '500',
        ...options
    }).then(() => {
        teardown();
        onOk();
    }).catch(() => {
        teardown();
        colse();
    });
}